import snakecaseKeys from 'snakecase-keys';
import {
    FormInteraction,
    FormInteractionEvent,
    FormInteractionType,
    FormStart,
    FormStartEvent,
    FormSuccess,
    FormSuccessEvent,
    GaEventType,
    requiresFormValue,
} from '../types/index.js';
import { buildBaseEvent } from './base-event-builder.js';

export function buildFormStartEvent<T extends FormStart>(options: T): FormStartEvent {
    return buildBaseEvent<FormStartEvent>(GaEventType.FormStart, options);
}

export function buildFormInteractionEvent<T extends FormInteraction>(options: T): FormInteractionEvent {
    const { formValue, errorData, ...restOptions } = options;

    const event = buildBaseEvent<FormInteractionEvent>(
        GaEventType.FormInteraction,
        restOptions
    );

    if (formValue && requiresFormValue(options.formInteraction)) {
        event.form_value = snakecaseKeys(formValue as any, { deep: true });
    }

    if (errorData && options.formInteraction === FormInteractionType.ERROR) {
        (event as any).error_data = snakecaseKeys(errorData as any, { deep: true });
    }

    return event;
}

export function buildFormSuccessEvent<T extends FormSuccess>(options: T): FormSuccessEvent {
    return buildBaseEvent<FormSuccessEvent>(GaEventType.FormSuccess, options);
}
